import {
    SlideCompanyLogosContainer,
    SlideContainer,
    SlideDescription,
    SlideImage,
    SlideTestimonial,
    SlideTitle,
} from './styles';

type SlideProps = {
    title: string;
    description: string;
    imageSrc: string;
    isActive: boolean;
    companyLogos: string[];
};

const Slide = ({ title, description, imageSrc, isActive, companyLogos }: SlideProps) => (
    <SlideContainer direction="column" align="center" justify="center" $isActive={isActive}>
        <SlideTitle>{title}</SlideTitle>
        <SlideDescription>{description}</SlideDescription>
        <SlideImage src={imageSrc} alt={title} />
        <SlideTestimonial>Used by</SlideTestimonial>
        <SlideCompanyLogosContainer align="center" justify="center">
            {companyLogos.map((logo) => (
                <SlideImage key={logo} src={logo} alt="Company logo" />
            ))}
        </SlideCompanyLogosContainer>
    </SlideContainer>
);

export default Slide;
